module.exports = __webpack_public_path__ + "static/media/image-in-cloud.52feaaeb.svg";